export const useFeedPostAction = async (
  id: string,
  adamActionParameters: any
): Promise<any> => {
  try {
    const { result, error } = await useApiFetch(`${URI.Feed}/${id}/action`, {
      method: 'POST',
      body: {
        ...adamActionParameters,
      },
    });
    if (error) {
      throw error;
    } else {
      return result;
    }
  } catch (e) {
    globalThis.$logger.info('useFeedPostAction :: error', e);
    return null;
  }
};
